import * as React from 'react';
import { FieldArray, FieldArrayRenderProps } from 'formik';

import { Button, Icons } from 'src/components';

interface IChildrenArgs {
  name: string;
  item: any;
}

interface IFormObjectListProps {
  name: string;
  addLabel?: string;
  addObject?: {};
  addDisabled?: boolean;
  removeDisabled?: boolean;
  children: (args: IChildrenArgs) => React.ReactChild;
}

export default class FormObjectList extends React.Component<IFormObjectListProps> {
  formRender = ({ remove, push, form }: FieldArrayRenderProps) => {
    const { name, children, addLabel, addObject, addDisabled, removeDisabled } =
      this.props;
    return (
      <>
        {form.values[name].map((item: any, index: number) => {
          const childrenProp = {
            name: `${name}.${index}`,
            item,
          };
          if (addLabel) {
            return (
              <div key={index} className={'flex items-center mb-3'}>
                {children(childrenProp)}
                <Button
                  onClick={remove.bind(null, index)}
                  size="small"
                  background="grey"
                  disabled={removeDisabled}
                >
                  <Icons.Trash size={16} />
                </Button>
              </div>
            );
          } else {
            return (
              <React.Fragment key={index}>
                {children(childrenProp)}
              </React.Fragment>
            );
          }
        })}
        {addLabel && (
          <Button
            onClick={push.bind(null, addObject)}
            className="mt-1"
            size="small"
            background="grey"
            disabled={addDisabled}
          >
            {addLabel}
          </Button>
        )}
      </>
    );
  };

  render() {
    return <FieldArray name={this.props.name} render={this.formRender} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/FormObjectList.tsx